<template>
    <div class="cursor-pointer product-card" :class="{ enstock: product.enStock, 'prod_in_cart': product.quantity > 0 }" elevation="0">
        <div class="img_infos_container">
            <div class="cursor-pointer imgcontainer" :id="product.reference">
                <!-- class="imgcontainer" -->
                <img v-if="product.nombreImages360 > 0 ||
                    product.nombreImagesAutre > 0
                    " @click.stop="toProductDetailsPage(product)" :src="imageUrlFromKey(imageKeys[currentImageIndex])"
                     @error="replaceByDefault"
                     @touchstart.passive="onTouchStart" @touchend="onTouchEnd"
                     class="prod-image"
                    :class="{ 'border-red': !product.enStock }" />
                <img v-else @click="toProductDetailsPage(product)" src="../assets/unknown2.jpg"
                     @error="replaceByDefault"
                     class="prod-image"
                    :class="{ 'border-red': !product.enStock }" />
                <template v-if="imageKeys.length > 1">
                    <button type="button" class="gallery-btn gallery-btn-prev" aria-label="Image précédente"
                        @click.stop="previousImage">
                        <v-icon small>mdi-chevron-left</v-icon>
                    </button>
                    <button type="button" class="gallery-btn gallery-btn-next" aria-label="Image suivante"
                        @click.stop="nextImage">
                        <v-icon small>mdi-chevron-right</v-icon>
                    </button>
                    <div class="gallery-dots">
                        <span v-for="(key, i) in imageKeys" :key="key" class="gallery-dot"
                            :class="{ 'gallery-dot-active': i == currentImageIndex }"
                            @click.stop="currentImageIndex = i"></span>
                    </div>
                </template>
                <div class="top-left prod_ref">
                    
                    <div class="red--text contour-text-blanc" v-if="hasOneOfRoles(['ROLE_ADMIN', 'ROLE_MANAGER'])">
                        {{ product.referenceFournisseur }} <span v-if="hasOneOfRoles(['ROLE_MANAGER'])">  / {{ product.stock }}</span></div>
                </div>

                <div class="bottom-right overline contour-text-blanc" style="color: black;">
                    <div style="font-size: 14px;" v-if="hasOneOfRoles(['ROLE_ADMIN'])">
                        {{ Math.round((product.prixA / product.prixAchat - 1) * 100) }}%</div>
                    <div style="font-size: 14px;" v-if="hasOneOfRoles(['ROLE_ADMIN'])">{{
                        Math.round(product.prixAchat * 100) / 100
                    }} €</div>
                    <div class="prod_udv"><span class="udv-x">X</span><span class="udv-val">{{ product.uniteDeVente }}</span> </div>
                    <div class="prod_ref"> <span>{{ product.reference }}</span> </div>
                </div>
                <div class="bottom-left overline black--text contour-text-blanc"
                    v-if="hasOneOfRoles(['ROLE_ADMIN', 'ROLE_MANAGER', 'ROLE_SHOWROOM'])">
                    <div>{{
                        product.stock
                    }}</div>
                    <v-btn class="overline" :color="product.enFavoris ? 'red' : 'black'" text="" small="" fab="" @click="toggleFavorite(product)">
                        <v-icon v-if="product.enFavoris">mdi-heart</v-icon>
                        <v-icon v-else>mdi-heart-outline</v-icon>
                    </v-btn>
                </div>
                

            </div>

            <div class="prod_infos_container">
                <div class="marque_dimensions" v-if="false">
                    <div class="marque">{{ product.marque }} </div>
                    <div class="separator" v-if="product.marque && product.dimensions"></div>
                    <div class="dimensions">{{ product.dimensions }}</div>
                </div>
                <div class="designation">{{ product.designation }} </div>
                <Prices :product="product" :userInfos="userInfos" />
            </div>
        </div>
        <PlusMoinsPanier class="plus_moins_panier_component" :product="product"></PlusMoinsPanier>
    </div>
</template>
   
<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import img from "../assets/unknown2.jpg";
import PlusMoinsPanier from "../components/PlusMoinsPanier";
import Prices from "./Prices.vue";
/* eslint-disable no-undef */

export default {
    props: {
        product: { required: true },
    },
    data: () => ({
        currentImageIndex: 0,
        touchStartX: null,
    }),
    components: {
        // eslint-disable-next-line vue/no-unused-components
        PlusMoinsPanier,
        Prices
    },
    methods: {
        hasOneOfRoles(roles) {
            //console.log('in has one of roles, userInfos ->', this.userInfos)
            return this.userInfos.roles
                .map(x => x.roleName)
                //.split(',')
                .some(role => roles.includes(role))
        },

        toggleFavorite(product) {
            //console.log('fav ->', product.reference)
            if (product.enFavoris) this.deleteFavoris(product);
            else this.addFavoris(product);
            product.enFavoris = !product.enFavoris;
            this.persistToggleFavoris(product);
        },
        toProductDetailsPage(product) {
            this.$emit('clicked', product)
        },
        imageUrlFromKey(key) {
            let url = this.imagesBaseURL;
            let index = key;
            if (key.startsWith("autre_")) {
                url += "/autre";
                index = key.split("_")[1];
            }
            return url + "/" + this.product.reference + "/" + index + ".jpg?" + this.product.imagesUUID;
        },
        previousImage() {
            this.currentImageIndex = (this.currentImageIndex - 1 + this.imageKeys.length) % this.imageKeys.length;
        },
        nextImage() {
            this.currentImageIndex = (this.currentImageIndex + 1) % this.imageKeys.length;
        },
        onTouchStart(e) {
            this.touchStartX = e.changedTouches[0].clientX;
        },
        onTouchEnd(e) {
            if (this.touchStartX === null || this.imageKeys.length < 2) return;
            const deltaX = e.changedTouches[0].clientX - this.touchStartX;
            this.touchStartX = null;
            if (Math.abs(deltaX) < 40) return;
            if (deltaX < 0) this.nextImage();
            else this.previousImage();
        },
        replaceByDefault(e) {
            console.log("on error");
            e.target.src = img;
        },
        ...mapActions([
            "persistToggleFavoris",
        ]),
        ...mapMutations([
            "addFavoris",
            "deleteFavoris",
        ]),


    },
    watch: {
        "product.reference"() {
            this.currentImageIndex = 0;
        },
    },
    computed: {
        // clés au format de imagePreview : "01" (360) ou "autre_01", la preview en premier
        imageKeys() {
            const pad = (i) => (i <= 9 ? "0" : "") + i;
            const preview = this.product.imagePreview;
            const keys = [];
            if (this.product.nombreImages360 > 0) {
                // une seule image pour la vue 360
                keys.push(preview && !preview.startsWith("autre_") ? preview : "01");
            }
            for (let i = 1; i <= this.product.nombreImagesAutre; i++) {
                keys.push("autre_" + pad(i));
            }
            const previewIndex = keys.indexOf(preview);
            if (previewIndex > 0) {
                keys.unshift(keys.splice(previewIndex, 1)[0]);
            }
            return keys;
        },
        ...mapGetters([
            "imagesBaseURL",
            "allCategoriesLevels",
            'userInfos',
        ])
    },

    async created() {

    },
    mounted() {
        //console.log("mounted product -> ", this.product);

    },

};
</script>
  
<style scoped>


.prod_ref {
    color: #535353;
    font-family: Inter;
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    /* 12px */
}

.prod_udv {
    color: #000;
    font-family: Inter;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
    /* 18px */
}
.prod_udv .udv-x {
    font-size: 8px;
}
.prod_udv .udv-val {
    font-size: 14px;
}
.product-card {
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-contentz: center;
    gap: 8px;
    align-self: stretch;
    border-radius: 12px;
    border: 1px solid #E6E6E6;
}

.prod_infos_container {
    display: flex;
    padding: 8px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
    flex: 1 0 0;
    align-self: stretch;
}

.marque_dimensions {
    display: flex;
    align-items: center;
    gap: 8px;
    align-self: stretch;
}

.marque {
    color: #A3A3A3;
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    /* 18px */
}

.separator {
    width: 1px;
    height: 14px;
    background: #A3A3A3;
}

.dimensions {
    color: #A3A3A3;
    font-family: Inter;
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    /* 15px */
}

.designation {
    color: #171717;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%;
    display:block;
    width:100%;
    /* 19.2px */
    align-selfz: stretch;
    flex-growz: 1;
    displayz: flex;
    align-itemsz: start;
    justify-contentz: start;
    text-align: start;
}


@media screen and (min-width: 1265px) {}

.img_infos_container {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-start;
    flex: 1 0 0;
    align-self: stretch;
}
.imgcontainer {
    position: relative;
    text-align: center;
    color: #606060;
    aspect-ratio: 1 / 1;
    /*transition: all 0.5s;
     Animation */
     overflow: hidden;
}
.imgcontainer .prod-image {
    width: 100%;
    height: 100%; 
    object-fit: cover;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    background-positionz: center center;
    /* Make the background image cover the area of the <div>, and clip the excess */
    background-sizez: cover;
    transformZ: translate(-50%, -50%);
}
.plus_moins_panier_component {
   width: 100%;
}

/* TODO: z-index:1000 pour productColumn:hover #REMEMBER_WHY*/

.prod_drapeau {
    widthz: 32px;
    height: auto;
}

/* Bottom right text */
.bottom-right {
    position: absolute;
    bottom: 8px;
    right: 16px;
}

.bottom-left {
    position: absolute;
    bottom: 3px;
    left: 3px;
    font-size: 14px;
}

.top-left {
    position: absolute;
    top: 8px;
    left: 16px;

}

.top-right {
    position: absolute;
    top: 0px;
    right: 0px;
}
.top-right-left {
    position: absolute;
    top: 3px;
    right: 35px;
}

.cursor-pointer {
    cursor: pointer;
}

.contour-text-blanc {
    text-shadow: -1px -1px 0 white, -1px 0px 0 white, -1px 1px 0 white, 0px -1px 0 white, 0px 0px 0 white, 0px 1px 0 white, 1px -1px 0 white, 1px 0px 0 white, 1px 1px 0 white
}


.gallery-btn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.85);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.2s;
    z-index: 1;
}
.gallery-btn-prev {
    left: 6px;
}
.gallery-btn-next {
    right: 6px;
}
.imgcontainer:hover .gallery-btn {
    opacity: 1;
}
.gallery-dots {
    position: absolute;
    top: 8px;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    gap: 4px;
    pointer-events: none;
}
.gallery-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.25);
    pointer-events: auto;
}
.gallery-dot-active {
    background-color: rgba(0, 0, 0, 0.7);
}
/* écrans tactiles : pas de hover, boutons toujours visibles */
@media (hover: none) {
    .gallery-btn {
        opacity: 1;
    }
}

.prods-side-container {}
.prod_in_cart {
    border: 1px solid #22C55E;
}
</style>